export const API_KEY="5a301a66dfc614c733d3a6e17f24378e";
export const TMDB_BASE_URL="https://api.themoviedb.org/3"